<template>
  <section>
    <b-modal
      id="modalSuscription"
      centered
      hide-footer
      hide-header
      hide-actions>
      <section class="c-modal-lection c-modal-lection--suscription">
        <div class="c-modal-lection__dialog">
          <section
            class="c-suscription br--small d-flex flex-column
              ustify-content-end position-relative"
          >
            <button
              @click="closeModal"
              class="c-suscription__close d-flex justify-content-center
                align-items-center position-absolute"
            >
              <i class="iconf-cancel"></i>
            </button>
            <div class="c-suscription__body position-relative h-100
              d-flex flex-column align-items-center justify-content-end text-center p-3 p-lg-4">
              <h3 class="w-bold fs-25 white">{{ body.title }}</h3>
              <p class="white w-medium fs-18 mb-4">{{ body.description }}</p>
              <a
                :href="premiumPlans"
                target="_blank"
                class="c-button c-button--primary d-inline-block"
              >
                Ver planes
              </a>
            </div>
          </section>
        </div>
      </section>
    </b-modal>
  </section>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      arcux: { ...window.arcux },
    };
  },
  props: ['body'],
  computed: {
    premiumPlans: function() {
      return `${this.arcux.site}/premium/#planes`;
    },
  },
  methods: {
    closeModal: function() {
      this.$bvModal.hide('modalSuscription');
    },
  },
}
</script>
